<template>
  <div
    class="quiz-progress position-fixed w-100 right-0 z-plus-2 bg-light-light-5 d-flex speed-base timing-standard"
    :class="{ 'quiz-progress--revealed' : progressRevealed }">
    <div class="quiz-progress__total h-100 d-none d-sm-flex align-items-center text-right position-absolute top-0 bottom-0 right-4 margin-auto font-weight-600">
      {{ displayNumber }}%
    </div>
    <div
      v-for="category in categories"
      :key="`progressbar-${category.id}`"
      class="position-relative quiz-progress__section w-33 h-100 text-uppercase d-flex align-items-center px-4 no-overflow">
      <div
        :style="`width: ${progressWidth(category.id)}%`"
        class="position-absolute quiz-progress__bar z-minus-1 h-100 top-0 left-0 timing-emphasized speed-slower"
        :class="[
          { 'bg-secondary-light-2' : category.id == 'skin' },
          { 'bg-secondary' : category.id == 'lifestyle' },
          { 'bg-secondary-dark-2' : category.id == 'environment' },
        ]" />
      <span class="position-relative z-plus-2 d-none d-sm-inline font-weight-600 clr-black-opacity-7">
        {{ category.name }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Progress',
  data() {
    return {
      progressRevealed: false,
      revealDelay: 1500, // ms
      displayNumber: 0,
      interval: false,
      categories: [
        {
          id: 'skin',
          name: 'Skin Concerns',
        },
        {
          id: 'lifestyle',
          name: 'Lifestyle',
        },
        {
          id: 'environment',
          name: 'Environment',
        }
      ],
    }
  },
  watch: {
    /* eslint-disable-next-line no-unused-vars */
    currentRoute(newVal, oldVal) {
      const self = this
      if (newVal == 'Questions') {
        setTimeout(() => {
          self.progressRevealed = true
        }, self.revealDelay)
      } else {
        self.progressRevealed = false
      }
    },

    questionsProgress() {
      clearInterval(this.interval)

      if (this.questionsProgress == this.displayNumber) {
        return
      }

      this.interval = window.setInterval(() => {
        if (this.displayNumber != this.questionsProgress) {
          var change = (this.questionsProgress - this.displayNumber) / 10
          change = change >= 0 ? Math.ceil(change) : Math.floor(change)
          this.displayNumber = this.displayNumber + change
        }
      }, 50)
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name
    },

    currentOrder: {
      get() {
        return this.$store.state.user.currentOrder
      },
      set(order) {
        return order
      }
    },

    questions() {
      return this.$store.state.user.questions
    },

    questionsLength() {
      return this.questions.length
    },

    categoryLength() {
      return {
        skin: this.questions.filter(q => q.category == 'skin').length,
        lifestyle: this.questions.filter(q => q.category == 'lifestyle').length,
      }
    },

    questionsProgress() {
      return this.$store.state.user.questionsProgress
    },

    environment() {
      return this.$store.state.user.environment
    },

    environmentReady() {
      return Object.keys(this.environment).length > 0
    },
  },
  methods: {
    progressWidth(category) {
      const stepValue = Math.round((100 / this.categoryLength[category]) * 100) / 100
      let pr

      if (this.currentRoute == 'Scanner' || this.currentRoute == 'Start') {
        pr = 0
      } else {
        if (this.currentOrder == 1 && category == 'skin') {
          pr = 4 // hardcoded value, preferably change in future
        } else {
          /* eslint-disable no-plusplus */
          const prev = --this.currentOrder
          if (category == 'skin') {
            pr = prev * stepValue
          } else if (category == 'lifestyle') {
            pr = (prev - this.categoryLength['skin']) * stepValue
          } else {
            this.environmentReady ? pr = 100 : pr = 0
          }
        }
      }

      return pr
    },
  },
  mounted() {
    this.displayNumber = this.questionsProgress ? this.questionsProgress : 0
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/@core/globals';

.quiz-progress {
  height: $progress-height-mobile;
  top: $header-height;
  border-bottom: 1px solid color('white');
  transform: translateY(-100%);

  @media #{$sm-up} {
    height: $progress-height-desktop;
  }

  &--revealed {
    transform: translateY(0);
  }

  &__section {
    &:not(:last-child) {
      border-right: 1px solid color('white');
    }
  }
}
</style>
